import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  GetLookupItemsByLookupTypeName,
  lookupItemsGetId,
} from "../../../Services";
import { AutocompleteComponent } from "../AutocompleteComponent/AutocompleteComponent";
import { ReskinningAutocomplete } from "../../V2";

function LookupAutocomplete({
  lookupTypeId,
  lookupParentId,
  parentTranslationPath,
  translationPath,
  selectedValues,
  multiple = false,
  required,
  onChange,
  wrapperClasses,
  label,
  disabled,
  className = "",
  lookupName,
  filterSelectedOptions,
  isSubmitted,
  withError,
  error,
  helperText,
  placeholder,
  inputClasses,
  filterOptions,
  disableClearable,
  labelClasses,
  isNewLayout = false,
}) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const getLookupData = useCallback(async () => {
    setIsLoading(true);
    let res;
    if (lookupTypeId) {
      res = await lookupItemsGetId({ lookupTypeId, lookupParentId });
    }
    if (lookupName) {
      const result = await GetLookupItemsByLookupTypeName({
        lookUpName: lookupName,
        pageIndex: 1,
        pageSize: 10000,
      });
      res = result.result;
    }
    setData(res);
    setIsLoading(false);
  }, [lookupTypeId, lookupParentId, lookupName]);

  useEffect(() => {
    if (!disabled) {
      getLookupData();
    }
  }, [getLookupData]);

  if (lookupName && lookupTypeId) {
    return (
      <h6 className="text-danger">
        You can't provide both lookupName and lookupTypeId at the same time
      </h6>
    );
  }
  if (!lookupName && !lookupTypeId) {
    return (
      <h6 className="text-danger">
        you must provide either lookupName or lookupTypeId
      </h6>
    );
  }

  if (isNewLayout) {
    return (
      <div className={className}>
        <ReskinningAutocomplete
          data={data}
          filterSelectedOptions={filterSelectedOptions}
          filterOptions={filterOptions}
          inputPlaceholder={placeholder}
          isSubmitted={isSubmitted}
          isWithError={withError}
          selectedValues={selectedValues}
          labelClasses={required ? "Requierd-Color" : ""}
          labelValue={label}
          multiple={multiple}
          error={error}
          helperText={helperText}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          displayLabel={(option) => option?.lookupItemName ?? ""}
          renderOption={(option) => option?.lookupItemName}
          chipsLabel={(option) => option?.lookupItemName}
          getOptionSelected={(option, value) =>
            option?.lookupItemId === value?.lookupItemId
          }
          isLoading={isLoading}
          onChange={onChange}
          wrapperClasses={wrapperClasses}
          withoutSearchButton
          isDisabled={disabled}
          inputClasses={inputClasses}
          disableClearable={disableClearable}
        />
      </div>
    );
  }

  return (
    <div className={className}>
      <AutocompleteComponent
        data={data}
        filterSelectedOptions={filterSelectedOptions}
        filterOptions={filterOptions}
        inputPlaceholder={placeholder}
        isSubmitted={isSubmitted}
        isWithError={withError}
        selectedValues={selectedValues}
        labelClasses={required ? "Requierd-Color" : ""}
        labelValue={label}
        multiple={multiple}
        error={error}
        helperText={helperText}
        parentTranslationPath={parentTranslationPath}
        translationPath={translationPath}
        displayLabel={(option) => option?.lookupItemName ?? ""}
        renderOption={(option) => option?.lookupItemName}
        chipsLabel={(option) => option?.lookupItemName}
        getOptionSelected={(option, value) =>
          option?.lookupItemId === value?.lookupItemId
        }
        isLoading={isLoading}
        onChange={onChange}
        wrapperClasses={wrapperClasses}
        withoutSearchButton
        isDisabled={disabled}
        inputClasses={inputClasses}
        disableClearable={disableClearable}
      />
    </div>
  );
}

LookupAutocomplete.propTypes = {
  lookupTypeId: PropTypes.number,
  lookupParentId: PropTypes.number,
  parentTranslationPath: PropTypes.string,
  translationPath: PropTypes.string,
  selectedValues: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  multiple: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  wrapperClasses: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  lookupName: PropTypes.string,
  filterSelectedOptions: PropTypes.bool,
  isSubmitted: PropTypes.bool,
  withError: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  placeholder: PropTypes.string,
  inputClasses: PropTypes.string,
  filterOptions: PropTypes.func,
  disableClearable: PropTypes.bool,
};

export default LookupAutocomplete;
